var map = {
	"./Logo desktop.svg": 1433,
	"./Logo mobile.svg": 5469,
	"./evtools.png": 3542,
	"./go-ral.png": 1110,
	"./legend/chargingpoint-alert.png": 6292,
	"./legend/chargingpoint-definitive.png": 6403,
	"./legend/chargingpoint-in-progress.png": 8729,
	"./legend/chargingpoint-realized.png": 3158,
	"./legend/chargingpoint-rejected.png": 6874,
	"./legend/chargingpoint-suggestion.png": 2363,
	"./legend/disabled.png": 2246,
	"./legend/map-pin-solid-red.png": 7948,
	"./legend/old/chargingpoint-alert.png": 3302,
	"./legend/old/chargingpoint-definitive.png": 2217,
	"./legend/old/chargingpoint-fastcharger-planned.png": 8709,
	"./legend/old/chargingpoint-fastcharger-realized.png": 1405,
	"./legend/old/chargingpoint-in-progress.png": 2851,
	"./legend/old/chargingpoint-realized-private.png": 3270,
	"./legend/old/chargingpoint-realized.png": 7104,
	"./legend/old/chargingpoint-suggestion.png": 4578,
	"./legend/parking-permit-areas.png": 9655,
	"./legend/request-accepted.png": 7581,
	"./legend/request-active.png": 2200,
	"./legend/request-connected.png": 3645,
	"./legend/request-open.png": 8770,
	"./legend/request-selected.png": 8617,
	"./opcharge.svg": 5373,
	"./park-n-charge.png": 3614,
	"./rvb.svg": 6970,
	"./vlaanderen.png": 3256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3760;